import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PERFIL_COPY } from '../../data/perfil-microempresario.content';
import { PerfilSolicitudService } from '../solicitud/perfil-solicitud.service';
import { UserService } from '../../../services/user.service';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';

/**
 * Pantalla de éxito tras enviar la solicitud de crédito.
 */
@Component({
  selector: 'app-perfil-solicitud-enviada',
  templateUrl: './perfil-solicitud-enviada.component.html',
  styleUrls: ['./perfil-solicitud-enviada.component.scss'],
  standalone: false,
})
export class PerfilSolicitudEnviadaComponent implements OnInit {
  readonly copy = PERFIL_COPY.solicitudEnviada;

  private solicitudId: string | null = null;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly solicitudService: PerfilSolicitudService,
    private readonly user: UserService,
    private readonly analyticsTag: AnalyticsTagService
  ) {}

  ngOnInit(): void {
    this.solicitudId = this.resolveSolicitudId();
    // Por si quedó draft de la sesión: tras envío no debe contaminar la siguiente.
    this.solicitudService.limpiarContextoCliente();
  }

  onVolverInicio(): void {
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.copy.ctaInicio,
      ctaSection: 'solicitud-enviada',
      ctaComponent: 'perfil-solicitud-enviada',
      ctaElementId: 'btn-solicitud-enviada-inicio',
      hu: '8099',
    });
    void this.router.navigateByUrl('/microempresario/home');
  }

  /** Abre el detalle compartido de la solicitud enviada. */
  onRevisarSolicitud(): void {
    this.analyticsTag.trackCtaClick({
      ctaLabel: this.copy.ctaRevisar,
      ctaSection: 'solicitud-enviada',
      ctaComponent: 'perfil-solicitud-enviada',
      ctaElementId: 'btn-solicitud-enviada-revisar',
      hu: '8099',
    });
    const id = this.resolveSolicitudId();
    if (id) {
      void this.router.navigate(['/solicitud', 'microempresario', id]);
      return;
    }
    void this.router.navigateByUrl('/microempresario/home');
  }

  private resolveSolicitudId(): string | null {
    const fromRoute = this.route.snapshot.paramMap.get('id');
    if (fromRoute) {
      return String(fromRoute);
    }
    const fromService = this.solicitudService.idSolicitud;
    if (fromService) {
      return String(fromService);
    }
    const fromUser = this.user.getUser()?.idSolicitud;
    return fromUser ? String(fromUser) : null;
  }
}
